import React from "react";
import notFound from "../../assets/404.png";

const NotFound = () => {
  return (
    <div className="flex justify-center items-center">
      <img className="w-6/12" src={notFound} alt="" srcset="" />
    </div>
  );
};

export default NotFound;
